import { PROJECT_FORMAT_VERSION, type Project } from '@/domain/types';
import { APP_VERSION } from '@/domain/project';

/**
 * Serialisation is deliberately a plain structural copy: the domain model is
 * already JSON-shaped, so there is no schema translation layer to drift out of
 * sync with the types. The only work done here is stamping write-time metadata.
 */
export function serializeProject(project: Project): string {
  return JSON.stringify(toSerializable(project));
}

export function toSerializable(project: Project): Project {
  return {
    ...project,
    meta: {
      ...project.meta,
      formatVersion: PROJECT_FORMAT_VERSION,
      appVersion: APP_VERSION,
      modifiedAt: Date.now(),
    },
  };
}

/** Deep structural clone used by autosave snapshots and undo checkpoints. */
export function cloneProject(project: Project): Project {
  const structured = (globalThis as { structuredClone?: <T>(value: T) => T }).structuredClone;
  if (structured) return structured(project);
  return JSON.parse(JSON.stringify(project)) as Project;
}
